import $ from 'jquery';
import _ from 'underscore';

$(document).ready(() => {
    function createToggleFunction(groupId) {
        const hideSelector = `[data-toggle-group-hide=${groupId}]`;
        const showSelector = `[data-toggle-group-show=${groupId}]`;

        const $hideElements = $(hideSelector);
        const $showElements = $(showSelector);

        $(`${hideSelector}, ${showSelector}`).each(function() {
            const $control = $(this);

            $control.data('required', $control.prop('required'));
        });

        function toggleElements($elements, show) {
            $elements.each(function() {
                const $control = $(this);
                const elementId = $control.attr('id');

                const $colContainer = $('#' + elementId).closest('[class^="col-md-"]');

                if ($colContainer.length > 0) {
                    const $parentContainer = $colContainer.parent();
                    if ($parentContainer.length > 0) {
                        $parentContainer.toggle(show);
                    } else {
                        $colContainer.toggle(show);
                    }
                } else {
                    const $formGroup = $control.closest('.form-group');
                    if ($formGroup.length > 0) {
                        $formGroup.toggle(show);
                    } else {
                        $control.toggle(show);
                    }
                }

                if ($control.data('required')) {
                    $control.prop('required', show);
                }

                if (show) {
                    const savedValue = $control.data('toggle-saved-value');
                    if (!_.isUndefined(savedValue)) {
                        $control.val(savedValue);
                    }
                } else {
                    $control.data('toggle-saved-value', $control.val());
                    const defaultValue = $control.data('toggle-default-value');
                    $control.val(defaultValue);
                }
            });
        }

        return function toggleGroups(selected) {
            toggleElements($hideElements, !selected);
            toggleElements($showElements, selected);
        }
    }

    $('input[type=checkbox][data-toggle-group]').each(function() {
        const $checkbox = $(this);

        const groupId = $checkbox.data('toggle-group');
        const toggleFunction = createToggleFunction(groupId);

        function toggleGroups() {
            const checked = $checkbox.prop('checked');

            toggleFunction(checked);
        }

        toggleGroups();

        $checkbox.on('change', toggleGroups);
    });

    const groupIds = $('option[data-toggle-group]').map(function() {
        return $(this).data('toggle-group');
    }).get();

    for (const groupId of _.uniq(groupIds)) {
        const $select = $(`option[data-toggle-group=${groupId}]`).closest('select');

        const toggleFunction = createToggleFunction(groupId);

        function toggleGroups() {
            const selected = $select.find(':selected').data('toggle-group') === groupId;

            toggleFunction(selected);
        }

        toggleGroups();

        $select.on('change', toggleGroups);
    }
});
